// External libraries
import React from 'react';
import { arrayOf, func, object, shape } from 'prop-types';
import { Interstitial, PayPalMonogram } from '@checkout/react-components';

// Internal modules
import { getContent, getLocale } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { FLAG_SPRITE_POSITION_MAP } from '@/styles';
import { handleCountryChange } from '../shared';
import {
  Container,
  CountryGroupContainer,
  CountryGroupHeader,
  CountryLink,
  CountryList,
  CountryListItem,
  FlagIcon,
  InterstitialFooter,
} from './StyledComponents';
import {
  interstitialHeaderStyleOverrides,
  interstitialStyleOverrides,
} from './styles';

const CountryChangeInterstitial = props => {
  useMountLogging('CountryChangeInterstitial');
  const { handleClose, territoriesByRegion } = props;
  const { country } = getLocale();

  return (
    <Interstitial
      headerStyleOverrides={interstitialHeaderStyleOverrides}
      interstitialStyleOverrides={interstitialStyleOverrides}
      onClose={handleClose}
      withoutPayPalLogo={true}
    >
      <Container>
        {Object.entries(territoriesByRegion).map(([region, countries]) => (
          <CountryGroupContainer key={region}>
            <CountryGroupHeader>
              {getContent(`regions.${region}`)}
            </CountryGroupHeader>
            <CountryList>
              {countries.map(({ code, name }) => {
                return (
                  code !== country && (
                    <CountryListItem key={code}>
                      <CountryLink
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          handleCountryChange({
                            fromCountry: country,
                            toCountry: code,
                          });
                        }}
                      >
                        <FlagIcon bgPosition={FLAG_SPRITE_POSITION_MAP[code]} />
                        <span>{name}</span>
                      </CountryLink>
                    </CountryListItem>
                  )
                );
              })}
            </CountryList>
          </CountryGroupContainer>
        ))}
      </Container>
      <InterstitialFooter>
        <PayPalMonogram />
      </InterstitialFooter>
    </Interstitial>
  );
};

CountryChangeInterstitial.propTypes = {
  handleClose: func.isRequired,
  territoriesByRegion: shape({
    AMERICAS: arrayOf(object).isRequired,
    APAC: arrayOf(object).isRequired,
    EMEA: arrayOf(object).isRequired,
  }).isRequired,
};

export { CountryChangeInterstitial };
